import styled, { css } from 'styled-components'

import { color } from '~/styles/utils'

export const ConsentCheckboxWrapper = styled.div<{ $alert?: boolean }>`
  margin-top: 10px;
  margin-bottom: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  ${({ $alert }) =>
    $alert &&
    css`
      border: 1px solid ${color('red')};
      color: ${color('red')};
      padding: 10px;
      margin: -11px;
      margin-top: 10px;
      margin-bottom: 10px;
    `};

  label {
    cursor: pointer;
    display: flex;
    align-items: center;

    input {
      cursor: pointer;
      flex: 0 0 24px;
    }

    p {
      margin: 0;
    }

    .description {
      margin-left: 8px;
    }

    .amp-button {
      text-decoration: underline;
      text-transform: none;
    }
  }
`
